export default "__VITE_ASSET__CwJwZMqz__"